import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import actionTypes from '../../actions/actionTypes'

const INIT_STATE = fromJS(PROGRAM_DEFAULT.movieMappings)

const reducers = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch (action.type) {
        case actionTypes.TMDB_MATCH_SUCCESS:
            return state.setIn(['items', action.payload.metaMoviePk, 'tmdb'], action.payload.tmdbUuid)

        case actionTypes.TMDB_UNMATCH_SUCCESS:
            return state.setIn(['items', action.payload.metaMoviePk, 'tmdb'], null)

        default:
            return state
    }
}

export default reducers
